module.exports = __webpack_public_path__ + "static/img/Business-Intelligence-BI.783405c3.jpg";